module.exports = __webpack_public_path__ + "static/img/baojingqueren2.39e9884.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/baojingqueren2.png
// module id = 81ml
// module chunks = 24